import { gql, type TypedDocumentNode } from '@apollo/client'

import * as Types from 'types/gql-global-types'

import {
  SavingsStartupDebitCardAccountV2FragmentDoc,
  SavingsStartupEntityFragmentDoc,
} from './SavingsStartup/SavingsStartup.generated'
import {
  SavingsStartupMarchDebitCardAccountV2FragmentDoc,
  SavingsStartupMarchEntityFragmentDoc,
} from './SavingsStartupMarch/SavingsStartupMarch.generated'

export type StartupModalSwitchEntityFragment = {
  __typename?: 'Entity'
  canCreateAccount: boolean | null
  savingsAccountProduct: {
    __typename?: 'EntitySavingsAccountProduct'
    baseInterestRate: string | null
    bonusInterestRate: string | null
    bonusLengthInDays: string | null
    effectiveInterestRate: string | null
  } | null
}

export type StartupModalSwitchDebitCardAccountV2Fragment = {
  __typename?: 'DebitCardAccountV2'
  id: string
  status: Types.DebitCardAccountStatus
}

export const StartupModalSwitchEntityFragmentDoc = gql`
  fragment StartupModalSwitchEntityFragment on Entity {
    ...SavingsStartupEntityFragment
    ...SavingsStartupMarchEntityFragment
  }
  ${SavingsStartupEntityFragmentDoc}
  ${SavingsStartupMarchEntityFragmentDoc}
` as unknown as TypedDocumentNode<StartupModalSwitchEntityFragment, undefined>
export const StartupModalSwitchDebitCardAccountV2FragmentDoc = gql`
  fragment StartupModalSwitchDebitCardAccountV2Fragment on DebitCardAccountV2 {
    ...SavingsStartupDebitCardAccountV2Fragment
    ...SavingsStartupMarchDebitCardAccountV2Fragment
  }
  ${SavingsStartupDebitCardAccountV2FragmentDoc}
  ${SavingsStartupMarchDebitCardAccountV2FragmentDoc}
`
